import ar from '../JsonLang/ar.json'
export const lang = { ...ar }
